
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import conso from '%/conso';
import ax, { INIT_INSTALLATIONS_DATA } from '%/axios';
import * as yup from 'yup';
import { Formik } from 'formik';
import * as uf from '%/functions'
import ReCAPTCHA from "react-google-recaptcha";
import { Combobox } from '../components/CustomFieldSection';
import AsyncImage from '../components/AsyncImage';
const GalleryItem = (props) => {

  const {
    make,
    model,
    sales_order_number,
    thumbnail_url,
    description,
    linkedin_link,
    instagram_link,
    location_built,
    lighting
  } = props;

  const handleLink = (link, type = 'instagram') => {
    if (!/^http/.test(link)) {
      if (type === 'instagram') {
        return 'https://instagram.com/' + link;
      } else if (type === 'linkedin')
        return 'https://linkedin.com/in/' + link;
    }
    return link;
  }


  return (
    <div id="w-node-_0966909e-5263-3614-e4b1-587d569ccf71-832f3000" class="vehicle-builds-item">
      <div class="vehicle-builds-item-heading-wrapper">
        <h3 class="vehicle-builds-item-heading">{make} {model}</h3>
        <div class="vehicle-builds-item-social-wrapper">
          <a href={handleLink(instagram_link)} target='_blank' class="vehicle-builds-item-social-link w-inline-block">
            <div class="icon-embed-small w-embed">
              <svg width="24" height="24" viewBox="0 0 132 132" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M103.411 37.6899C102.541 35.4499 101.501 33.8499 99.8206 32.1699C98.1406 30.4899 96.5406 29.4499 94.3006 28.5799C92.6106 27.9199 90.0706 27.1399 85.3906 26.9299C80.3306 26.6999 78.8106 26.6499 65.9906 26.6499C64.3906 26.6499 62.9606 26.6499 61.6806 26.6499C52.7306 26.6499 51.0206 26.7099 46.5906 26.9099C41.9106 27.1299 39.3706 27.8999 37.6806 28.5699C35.4406 29.4399 33.8406 30.4799 32.1606 32.1599C30.4806 33.8399 29.4406 35.4399 28.5706 37.6799C27.9106 39.3699 27.1306 41.9099 26.9206 46.5899C26.6906 51.6499 26.6406 53.1599 26.6406 65.9799C26.6406 78.7999 26.6906 80.3199 26.9206 85.3799C27.1306 90.0599 27.9206 92.5999 28.5706 94.2899C29.4406 96.5299 30.4806 98.1299 32.1606 99.8099C33.8406 101.49 35.4406 102.53 37.6806 103.4C39.3706 104.06 41.9106 104.84 46.5906 105.05C51.6506 105.28 53.1706 105.33 65.9906 105.33C78.8106 105.33 80.3306 105.28 85.3906 105.05C90.0706 104.84 92.6106 104.06 94.3006 103.4C96.5406 102.53 98.1406 101.49 99.8206 99.8099C101.501 98.1299 102.541 96.5399 103.411 94.2999C104.071 92.6099 104.851 90.0699 105.061 85.3899C105.291 80.3299 105.341 78.8099 105.341 65.9999C105.341 53.1899 105.291 51.6699 105.061 46.6099C104.851 41.9299 104.061 39.3899 103.411 37.6999V37.6899ZM65.9906 90.6499C52.3806 90.6499 41.3406 79.6199 41.3406 65.9999C41.3406 52.3799 52.3806 41.3499 65.9906 41.3499C79.6006 41.3499 90.6406 52.3899 90.6406 65.9999C90.6406 79.6099 79.6106 90.6499 65.9906 90.6499ZM91.6206 46.1399C88.4406 46.1399 85.8606 43.5599 85.8606 40.3799C85.8606 37.1999 88.4406 34.6199 91.6206 34.6199C94.8006 34.6199 97.3806 37.1999 97.3806 40.3799C97.3806 43.5599 94.8006 46.1399 91.6206 46.1399Z"
                  fill="currentColor"></path>
                <path
                  d="M65.9902 82.01C74.8268 82.01 81.9902 74.8466 81.9902 66.01C81.9902 57.1735 74.8268 50.01 65.9902 50.01C57.1537 50.01 49.9902 57.1735 49.9902 66.01C49.9902 74.8466 57.1537 82.01 65.9902 82.01Z"
                  fill="currentColor"></path>
                <path
                  d="M130.891 29.18C130.481 23.96 129.591 20.45 127.761 16.74C126.271 13.7 124.611 11.44 122.191 9.12001C117.891 5.01001 112.631 2.51001 106.361 1.61001C103.321 1.17001 102.721 1.04001 87.1805 1.01001H66.0205C38.8805 1.01001 30.9405 1.04001 29.4005 1.17001C23.8305 1.63001 20.3605 2.51001 16.5905 4.39001C13.6805 5.84001 11.3805 7.51001 9.12054 9.86001C5.00054 14.14 2.50054 19.41 1.59054 25.67C1.15054 28.71 1.02054 29.33 1.00054 44.86C0.990538 50.04 1.00054 56.85 1.00054 65.98C1.00054 93.1 1.03054 101.03 1.16054 102.57C1.61054 107.99 2.46054 111.4 4.26054 115.13C7.70054 122.27 14.2705 127.63 22.0105 129.63C24.6905 130.32 27.6505 130.7 31.4505 130.88C33.0605 130.95 49.4705 131 65.8905 131C82.3105 131 98.7305 130.98 100.301 130.9C104.701 130.69 107.261 130.35 110.081 129.62C117.871 127.61 124.321 122.33 127.831 115.09C129.601 111.45 130.491 107.91 130.901 102.77C130.991 101.65 131.021 83.79 131.021 65.96C131.021 48.13 130.981 30.3 130.891 29.18ZM113.701 85.79C113.461 90.9 112.651 94.39 111.471 97.44C110.241 100.6 108.601 103.27 105.931 105.94C103.261 108.61 100.591 110.25 97.4305 111.48C94.3805 112.67 90.8805 113.48 85.7705 113.71C80.6505 113.94 79.0205 114 65.9805 114C52.9405 114 51.3105 113.94 46.1905 113.71C41.0805 113.48 37.5905 112.67 34.5405 111.48C31.3905 110.25 28.7105 108.61 26.0405 105.94C23.3705 103.27 21.7305 100.59 20.5005 97.44C19.3105 94.39 18.5105 90.9 18.2705 85.79C18.0405 80.67 17.9805 79.04 17.9805 66C17.9805 52.96 18.0405 51.33 18.2705 46.21C18.5005 41.1 19.3105 37.61 20.5005 34.56C21.7305 31.4 23.3705 28.73 26.0405 26.06C28.7105 23.39 31.3905 21.75 34.5405 20.53C37.5905 19.34 41.0805 18.53 46.1905 18.3C51.3105 18.07 52.9505 18.01 65.9705 18.01H65.9805C79.0105 18.01 80.6405 18.07 85.7605 18.3C90.8705 18.53 94.3605 19.34 97.4205 20.53C100.581 21.75 103.251 23.39 105.921 26.06C108.591 28.73 110.231 31.41 111.461 34.56C112.641 37.61 113.451 41.1 113.691 46.21C113.921 51.33 113.981 52.97 113.981 66C113.981 79.03 113.921 80.67 113.691 85.79H113.701Z"
                  fill="currentColor"></path>
              </svg></div>
          </a>
          <a href={handleLink(linkedin_link, 'linkedin')} target='_blank' class="vehicle-builds-item-social-link w-inline-block">
            <div class="icon-embed-small w-embed">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.94043 5.00002C6.94016 5.53046 6.7292 6.03906 6.35394 6.41394C5.97868 6.78883 5.46986 6.99929 4.93943 6.99902C4.409 6.99876 3.90039 6.78779 3.52551 6.41253C3.15062 6.03727 2.94016 5.52846 2.94043 4.99802C2.9407 4.46759 3.15166 3.95899 3.52692 3.5841C3.90218 3.20922 4.411 2.99876 4.94143 2.99902C5.47186 2.99929 5.98047 3.21026 6.35535 3.58552C6.73024 3.96078 6.9407 4.46959 6.94043 5.00002V5.00002ZM7.00043 8.48002H3.00043V21H7.00043V8.48002ZM13.3204 8.48002H9.34043V21H13.2804V14.43C13.2804 10.77 18.0504 10.43 18.0504 14.43V21H22.0004V13.07C22.0004 6.90002 14.9404 7.13002 13.2804 10.16L13.3204 8.48002V8.48002Z"
                  fill="currentColor"></path>
              </svg>
            </div>
          </a>
        </div>
      </div>
      <AsyncImage
        path={thumbnail_url}
        imageClassName='vehicle-builds-item-heading-wrapper'
      />
      {/* <img src="/images/Picture1.jpg" loading="lazy" alt="" class="vehicle-builds-item-heading-wrapper" /> */}
      <div class="vehicle-build-item-details-wrapper">
        {
          lighting &&
          <div class="vehicle-build-item-detail">
            <div>Lighting: {lighting}</div>
          </div>
        }
        {
          location_built &&
          <div class="vehicle-build-item-detail">
            <div>Location Built: {location_built}</div>
          </div>
        }
        {
          sales_order_number &&
          <div class="vehicle-build-item-detail">
            <div>Sales Order: #{sales_order_number}</div>
          </div>
        }
      </div>
      {
        description &&
        <div class="vehicle-builds-item-description">{description}</div>
      }
    </div>
  )
}

const InstallationsGallery = () => {

  const [data, setData] = useState({})
  const [form, setForm] = useState({});
  const [results, setResults] = useState([]);

  const parseInstallationsData = (arr = []) => {
    // { Dodge: [{model: 'Durango', ...}], Chevrolet: [{model: 'Camaro', ...}] }
    const stg = arr.reduce((acc, each) => {

      if (acc[each.make]) {
        acc[each.make].push(each);
      } else {
        acc[each.make] = [each];
      }
      return acc;
    }, {})

    return stg;
  }

  const handleSearch = async (body = {}) => {
    try {
      const res = await ax(INIT_INSTALLATIONS_DATA, { ...body });
      if (res) {
        setResults(res);
      }
    } catch (er) {
      console.error(er);
    }
  }

  const initData = async () => {
    try {
      const res = await ax(INIT_INSTALLATIONS_DATA);
      if (res) {
        const stg = parseInstallationsData(res);
        setData(stg);
      }
    } catch (er) {
      console.error(er);
    }
  }

  const handleChange = (name) => {
    return (val) => {
      setForm(prev => ({ ...prev, [name]: val.trim() }))
      handleSearch({ ...form, [name]: val.trim() })
    }
  }
  const determineModelList = () => {
    if (form.make && data[form.make]) {

      return data[form.make].map(each => each.model)
        .filter((each, idx, array) => array.indexOf(each) == idx)
        .sort((a, b) => b > a ? -1 : 1);

    }
    return Object.values(data)
      .flat()
      .filter(each => {
        if (form.make) {
          const reg = new RegExp(form.make, 'ig')
          return reg.test(each.make);
        }
        return true;
      })
      .map(each => each.model)
      .filter((each, idx, array) => array.indexOf(each) == idx)
      .sort((a, b) => b > a ? -1 : 1)
  }
  const determineLocationList = () => {
    let list = [];
    if (form.make && data[form.make]) {

      list = data[form.make];
      if(form.model && data[form.model]) {
        list = list.filter(each => {
          if (form.model) {
            const reg = new RegExp(form.location_built, 'ig')
            return reg.test(each.location_built);
          }
          return true;
          
        })
      }
      return list.map(each => each.location_built)
      .filter(each => each) // filter nulls
      .filter((each, idx, array) => array.indexOf(each) == idx) // filter duplicates
      .sort((a, b) => b > a ? -1 : 1); // sort alphabetical order
    }
    return Object.values(data)
      .flat()
      .filter(each => {
        if (form.make) {
          const reg = new RegExp(form.make, 'ig')
          return reg.test(each.make);
        }
        return true;
      })
      .filter(each => {
        if (form.model) {
          const reg = new RegExp(form.model, 'ig')
          return reg.test(each.model);
        }
        return true;
      })
      .map(each => each.location_built)
      .filter((each, idx, array) => array.indexOf(each) == idx)
      .sort((a, b) => b > a ? -1 : 1)
  }

  useEffect(() => {
    initData();
  }, [])

  const parsedList = (results?.length ? results : Object.values(data)?.flat())
    // ?.slice(0, 3)
    .map(each =>

      <GalleryItem
        key={each.id}
        {...each}
      />
    )


  return (
    <>
      <div class="gallery-hero">
        <div class="news-hero-gradient">
          <div class="gradient-bokeh"></div>
        </div>
        <div class="container home-2-hero-flex">
          <div class="news-hero-content-wrapper">
            <h1 class="home-hero-heading">Vehicle <span class="gradient-span">Upfit Gallery.</span></h1>
            <div class="paragraph-20 max-width-640px">Get inspired! Search by Make, Model & Package Type to find your perfect build!</div>
            <div class="gallery-search-wrapper">
              <div class="gallery-search-form w-form">
                <form id="email-form" name="email-form" data-name="Email Form" method="get"
                  class="gallery-search-form-block" data-wf-page-id="679bb9eb0ca10d6d832f3000"
                  data-wf-element-id="9aa0a74c-1d38-3164-d6b3-d8ddc1f9fc97">
                  <div class="gallery-search-content">
                    <Combobox
                      limit={999}
                      inputClassName='gallery-search-input w-input'
                      name='make'
                      value={form.make}
                      list={Object.keys(data).sort((a, b) => b > a ? -1 : 1)}
                      handleChange={handleChange('make')}
                      placeholder='Search builds by Make...'
                    />

                    <div class="search-icon w-embed">
                      <svg width="16" height="16" viewbox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></circle>
                        <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="gallery-search-content">
                    <Combobox
                      limit={999}
                      inputClassName='gallery-search-input w-input'
                      name='model'
                      value={form.model}
                      list={determineModelList()}
                      handleChange={handleChange('model')}

                      placeholder='Search Model...'
                    />

                    <div class="search-icon w-embed">
                      <svg width="16" height="16" viewbox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></circle>
                        <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="gallery-search-content" >
                    <Combobox
                      handleChange={handleChange('location_built')}
                      inputClassName='gallery-search-input w-input'
                      name='location_built'
                      value={form.location_built}
                      list={determineLocationList()}
                      placeholder='Search Location Built...'
                    />

                    <div class="search-icon w-embed">
                      <svg width="16" height="16" viewbox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></circle>
                        <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                  </div>
                  <div class="gallery-search-content" >
                    <Combobox
                      handleChange={handleChange('build_type')}
                      inputClassName='gallery-search-input w-input'
                      name='build_type'
                      value={form.build_type}
                      list={['Patrol', 'Slick Top', 'Specialty']}
                      placeholder='Search Build Type...'
                    />

                    <div class="search-icon w-embed">
                      <svg width="16" height="16" viewbox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></circle>
                        <path d="M12.0122 12.3235L14.3616 14.6667" stroke="#B3B3B3" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                  </div>
                 
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gallery-body">
        <div class="container w-container">
          <div class="vehicle-builds-wrapper">
            {/* <div id="w-node-_9d97bc68-7550-1b67-550f-48c831758e5b-832f3000" class="vehicle-builds-item">
              <div class="vehicle-builds-item-heading-wrapper">
                <h3 class="vehicle-builds-item-heading">Dodge Durango</h3>
                <div class="vehicle-builds-item-social-wrapper">
                  <a href="#" class="vehicle-builds-item-social-link w-inline-block">
                    <div class="icon-embed-small w-embed"><svg width="100%" height="100%" viewbox="0 0 32 32" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M103.411 37.6899C102.541 35.4499 101.501 33.8499 99.8206 32.1699C98.1406 30.4899 96.5406 29.4499 94.3006 28.5799C92.6106 27.9199 90.0706 27.1399 85.3906 26.9299C80.3306 26.6999 78.8106 26.6499 65.9906 26.6499C64.3906 26.6499 62.9606 26.6499 61.6806 26.6499C52.7306 26.6499 51.0206 26.7099 46.5906 26.9099C41.9106 27.1299 39.3706 27.8999 37.6806 28.5699C35.4406 29.4399 33.8406 30.4799 32.1606 32.1599C30.4806 33.8399 29.4406 35.4399 28.5706 37.6799C27.9106 39.3699 27.1306 41.9099 26.9206 46.5899C26.6906 51.6499 26.6406 53.1599 26.6406 65.9799C26.6406 78.7999 26.6906 80.3199 26.9206 85.3799C27.1306 90.0599 27.9206 92.5999 28.5706 94.2899C29.4406 96.5299 30.4806 98.1299 32.1606 99.8099C33.8406 101.49 35.4406 102.53 37.6806 103.4C39.3706 104.06 41.9106 104.84 46.5906 105.05C51.6506 105.28 53.1706 105.33 65.9906 105.33C78.8106 105.33 80.3306 105.28 85.3906 105.05C90.0706 104.84 92.6106 104.06 94.3006 103.4C96.5406 102.53 98.1406 101.49 99.8206 99.8099C101.501 98.1299 102.541 96.5399 103.411 94.2999C104.071 92.6099 104.851 90.0699 105.061 85.3899C105.291 80.3299 105.341 78.8099 105.341 65.9999C105.341 53.1899 105.291 51.6699 105.061 46.6099C104.851 41.9299 104.061 39.3899 103.411 37.6999V37.6899ZM65.9906 90.6499C52.3806 90.6499 41.3406 79.6199 41.3406 65.9999C41.3406 52.3799 52.3806 41.3499 65.9906 41.3499C79.6006 41.3499 90.6406 52.3899 90.6406 65.9999C90.6406 79.6099 79.6106 90.6499 65.9906 90.6499ZM91.6206 46.1399C88.4406 46.1399 85.8606 43.5599 85.8606 40.3799C85.8606 37.1999 88.4406 34.6199 91.6206 34.6199C94.8006 34.6199 97.3806 37.1999 97.3806 40.3799C97.3806 43.5599 94.8006 46.1399 91.6206 46.1399Z"
                        fill="currentColor"></path>
                      <path
                        d="M65.9902 82.01C74.8268 82.01 81.9902 74.8466 81.9902 66.01C81.9902 57.1735 74.8268 50.01 65.9902 50.01C57.1537 50.01 49.9902 57.1735 49.9902 66.01C49.9902 74.8466 57.1537 82.01 65.9902 82.01Z"
                        fill="currentColor"></path>
                      <path
                        d="M130.891 29.18C130.481 23.96 129.591 20.45 127.761 16.74C126.271 13.7 124.611 11.44 122.191 9.12001C117.891 5.01001 112.631 2.51001 106.361 1.61001C103.321 1.17001 102.721 1.04001 87.1805 1.01001H66.0205C38.8805 1.01001 30.9405 1.04001 29.4005 1.17001C23.8305 1.63001 20.3605 2.51001 16.5905 4.39001C13.6805 5.84001 11.3805 7.51001 9.12054 9.86001C5.00054 14.14 2.50054 19.41 1.59054 25.67C1.15054 28.71 1.02054 29.33 1.00054 44.86C0.990538 50.04 1.00054 56.85 1.00054 65.98C1.00054 93.1 1.03054 101.03 1.16054 102.57C1.61054 107.99 2.46054 111.4 4.26054 115.13C7.70054 122.27 14.2705 127.63 22.0105 129.63C24.6905 130.32 27.6505 130.7 31.4505 130.88C33.0605 130.95 49.4705 131 65.8905 131C82.3105 131 98.7305 130.98 100.301 130.9C104.701 130.69 107.261 130.35 110.081 129.62C117.871 127.61 124.321 122.33 127.831 115.09C129.601 111.45 130.491 107.91 130.901 102.77C130.991 101.65 131.021 83.79 131.021 65.96C131.021 48.13 130.981 30.3 130.891 29.18ZM113.701 85.79C113.461 90.9 112.651 94.39 111.471 97.44C110.241 100.6 108.601 103.27 105.931 105.94C103.261 108.61 100.591 110.25 97.4305 111.48C94.3805 112.67 90.8805 113.48 85.7705 113.71C80.6505 113.94 79.0205 114 65.9805 114C52.9405 114 51.3105 113.94 46.1905 113.71C41.0805 113.48 37.5905 112.67 34.5405 111.48C31.3905 110.25 28.7105 108.61 26.0405 105.94C23.3705 103.27 21.7305 100.59 20.5005 97.44C19.3105 94.39 18.5105 90.9 18.2705 85.79C18.0405 80.67 17.9805 79.04 17.9805 66C17.9805 52.96 18.0405 51.33 18.2705 46.21C18.5005 41.1 19.3105 37.61 20.5005 34.56C21.7305 31.4 23.3705 28.73 26.0405 26.06C28.7105 23.39 31.3905 21.75 34.5405 20.53C37.5905 19.34 41.0805 18.53 46.1905 18.3C51.3105 18.07 52.9505 18.01 65.9705 18.01H65.9805C79.0105 18.01 80.6405 18.07 85.7605 18.3C90.8705 18.53 94.3605 19.34 97.4205 20.53C100.581 21.75 103.251 23.39 105.921 26.06C108.591 28.73 110.231 31.41 111.461 34.56C112.641 37.61 113.451 41.1 113.691 46.21C113.921 51.33 113.981 52.97 113.981 66C113.981 79.03 113.921 80.67 113.691 85.79H113.701Z"
                        fill="currentColor"></path>
                    </svg></div>
                  </a>
                  <a href="#" class="vehicle-builds-item-social-link w-inline-block">
                    <div class="icon-embed-small w-embed"><svg width="24" height="24" viewbox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.94043 5.00002C6.94016 5.53046 6.7292 6.03906 6.35394 6.41394C5.97868 6.78883 5.46986 6.99929 4.93943 6.99902C4.409 6.99876 3.90039 6.78779 3.52551 6.41253C3.15062 6.03727 2.94016 5.52846 2.94043 4.99802C2.9407 4.46759 3.15166 3.95899 3.52692 3.5841C3.90218 3.20922 4.411 2.99876 4.94143 2.99902C5.47186 2.99929 5.98047 3.21026 6.35535 3.58552C6.73024 3.96078 6.9407 4.46959 6.94043 5.00002V5.00002ZM7.00043 8.48002H3.00043V21H7.00043V8.48002ZM13.3204 8.48002H9.34043V21H13.2804V14.43C13.2804 10.77 18.0504 10.43 18.0504 14.43V21H22.0004V13.07C22.0004 6.90002 14.9404 7.13002 13.2804 10.16L13.3204 8.48002V8.48002Z"
                        fill="currentColor"></path>
                    </svg>
                    </div>
                  </a>
                </div>
              </div>
              <img src="/images/Picture1.jpg" loading="lazy" alt="" class="vehicle-builds-item-heading-wrapper" />
              <div class="vehicle-build-item-details-wrapper">
                <div class="vehicle-build-item-detail">
                  <div>Lighting: SoundOff+Blueprint</div>
                </div>
                <div class="vehicle-build-item-detail">
                  <div>Location Built: Clinton, NC</div>
                </div>
                <div class="vehicle-build-item-detail">
                  <div>Sales Order: #000000</div>
                </div>
              </div>
              <div class="vehicle-builds-item-description">Clinton PD receives a smooth new Durango for their fleet! This
                powerhouse features a SoundOff Blueprint system expertly installed by Dana Safety Supply’s Clinton, NC Team.
                It features a durable single prisoner transport partition from Setina, and a dependable Havis console. With
                this configuration it’s ready to protect and serve Clinton with maximum efficiency!</div>
            </div> */}
            {parsedList}
          </div>
        </div>
      </div>
    </>
  )
}



ReactDOM.render(<InstallationsGallery />, document.getElementById('installations-gallery'));
